import { render, staticRenderFns } from "./FpuiAccordionSection.vue?vue&type=template&id=9ff90b14&lang=pug&"
import script from "./FpuiAccordionSection.vue?vue&type=script&lang=js&"
export * from "./FpuiAccordionSection.vue?vue&type=script&lang=js&"
import style0 from "./FpuiAccordionSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports